import {axiosRequest} from "../../api";
import {API_PATH} from "../../../constants";

export const PatientProgramService = {
  getPatientProgramsList(params){ return axiosRequest('GET', API_PATH.PATIENT_PROGRAM.LIST(params)) },
  getPatientProgram(data){ return axiosRequest('POST', API_PATH.PATIENT_PROGRAM.INFO, data) },
  addPatientProgram(data){ return axiosRequest('POST', API_PATH.PATIENT_PROGRAM.ADD, data) },
  deletePatientProgram(data){ return axiosRequest('POST', API_PATH.PATIENT_PROGRAM.DELETE, data) },
}